import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { container } from "tsyringe";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import UpcomingActionResponseResource from "common/resources/Project/Config/UpcomingAction/UpcomingActionResponseResource";
import { useProjectId } from "hooks/useProjectId";
import UpcomingActionService from "services/projects/UpcomingActionService";
import { translateISO369 } from "utils/I18nText";
import ActionProgressTag from "./ActionProgressTag";
import classes from "./classes.module.scss";

type IProps = {
	action: UpcomingActionResponseResource;
};

const upcomingActionService = container.resolve(UpcomingActionService);

export default function ActionCard(props: IProps) {
	const { image } = useActionInfo(props.action);

	return (
		<div className={classes["root"]}>
			<LazyImage src={image} alt="" className={classes["image"]} />

			<div className={classes["action-info-container"]}>
				<div className={classes["action-info"]}>
					<Typography type="h4" weight="bold">
						{translateISO369(props.action.title)}
					</Typography>
					{props.action.startsAt && props.action.endsAt && <ActionProgressTag startsAt={props.action.startsAt} endsAt={props.action.endsAt} />}
					<Typography type="p" weight="regular" className={classes["description"]}>
						{translateISO369(props.action.description)}
					</Typography>
				</div>
				{props.action.buttonLabel && props.action.buttonLink && (
					<Link to={props.action.buttonLink} target="_blank">
						<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY}>
							{translateISO369(props.action.buttonLabel)}
						</Button>
					</Link>
				)}
			</div>
		</div>
	);
}

const useActionInfo = (action: UpcomingActionResponseResource) => {
	const [image, setImage] = useState<string | null>(null);
	const { projectId } = useProjectId();

	const fetchImage = useCallback(() => {
		if (action.image) upcomingActionService.downloadImage(projectId, action.id).then((blob) => setImage(URL.createObjectURL(blob)));
	}, [action.id, action.image, projectId]);

	useEffect(() => {
		fetchImage();
	}, [fetchImage]);

	return { image };
};
